import { RootState } from '../../store/reducers';
export const cardsSelector = (state: RootState) => state.cards;
export const myCardsSelector = (state: RootState) => state.cards.getMyCards;
export const transactionsByCardSelector = (state: RootState) => state.cards.transactionsByCard;
export const cardsOperationsPageSelectedCardSelector = (state: RootState) => state.cards.cardsOperationsPageSelectedCard;